module.exports = __webpack_public_path__ + "static/media/grc-introd-preview.0a2ea841.jpg";